import React from 'react';
import {
  Container,
  ContainerStyled,
  HexagonContainer,
  HexagonContent,
} from './HexagonalCard.styled';
import CategoryHeading from '../Heading/CategoryHeading';

const HexagonalCard = ({ data }) => {
  const { headerData, content } = data;
  return (
    <ContainerStyled className='container'>
      <CategoryHeading
        headerLeftTitle={headerData?.header}
        headerRightTitle={headerData?.subHeader}
      />
      <Container
        gridValue={content?.length}
        id='WeAreXpressBees'
        data-testid='We-Are-XpressBees-test'
      >
        {content?.map(({ icon, heading, subHeading }) => (
          <HexagonContainer key={heading}>
            <HexagonContent>
              <img className='iconStyle' src={icon} alt='icon' loading='lazy' />
              <div className='headingStyle'>{heading}</div>
              <div className='subHeadingStyle'>{subHeading}</div>
            </HexagonContent>
          </HexagonContainer>
        ))}
      </Container>
    </ContainerStyled>
  );
};

export default HexagonalCard;
